import { FlexColumn } from '@/atoms/FlexContainers'
import { Image } from '@/atoms/Image'
import { CaptionSM, TitleXS } from '@/atoms/Text'

interface CtaProps {
  imgSrc: string
  imgAlt: string
  fromColor: string
  title: string
  subtitle: string
  onClick: () => void
}

export const Cta = ({ imgSrc, imgAlt, fromColor, title, subtitle, onClick }: CtaProps) => {
  return (
    <FlexColumn
      className="align-items-center cursor-pointer justify-center overflow-hidden rounded-xl"
      onClick={onClick}
    >
      <div className="relative h-[120px] w-[420px] overflow-hidden md:h-[130px]">
        <div className="absolute inset-0 flex items-center justify-center">
          <Image src={imgSrc} width={420} height={130} className="object-cover" alt={imgAlt} />
        </div>
        <div className="absolute left-0 top-0 z-10 h-[160px] w-full min-w-[200px] lg:!h-[140px]">
          <div className="relative flex w-full justify-end">
            <div
              className="relative left-0 top-0 z-10 block h-[120px] w-[400px] md:h-[130px] lg:!h-[140px]"
              style={{
                background: `linear-gradient(to right, ${fromColor}, transparent 100%)`,
              }}
            />
            <div className="w-[250px] lg:w-[215px]" />
          </div>
        </div>
        <div className="absolute left-0 top-0 z-10 h-[160px] w-full min-w-[200px] lg:!h-[140px]">
          <div className="relative flex w-full flex-col justify-start gap-1 p-4 text-left text-white md:gap-2">
            <TitleXS weight="semibold" className="md:photon-title-lg md:font-bold">
              {title}
            </TitleXS>
            <CaptionSM weight="medium" className="md:photon-title-xs md:font-normal">
              {subtitle}
            </CaptionSM>
          </div>
        </div>
      </div>
    </FlexColumn>
  )
}
